/** Limit number of item when call get list API */
export const API_LIMIT = 10 as const
